import React, { useState, useEffect, useRef } from 'react';
import styles from './profileMedecin.module.css';
import HeaderBlack from '../../components/header/headerBlack/headerBlack'
import StatusCard from '../../components/statusCard/statusCard'
import banner from '../../assets/img/Rectangle.png';
import { getAuth, onAuthStateChanged, updatePassword } from 'firebase/auth';
import { getFirestore, doc, getDoc, updateDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { generateInvoicePDF } from '../../utils/pdfInvoice';
const ProfileMedecin = () => {
    const [activeTab, setActiveTab] = useState('profile');
    const [userName, setUserName] = useState('');
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [facturePatients, setFacturePatients] = useState([]);
    const [paymentsLoading, setPaymentsLoading] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const db = getFirestore();
        
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                try {
                    // Query the medecins collection to find the document with matching UID
                    const medecinsRef = collection(db, "medecins");
                    const q = query(medecinsRef, where("uid", "==", user.uid));
                    const querySnapshot = await getDocs(q);
                    
                    if (!querySnapshot.empty) {
                        const medecinData = querySnapshot.docs[0].data();
                        const medecinId = querySnapshot.docs[0].id;
                        setUserData({ id: medecinId, ...medecinData });
                        setUserName(medecinData.name || user.displayName || 'Utilisateur');
                        // Fetch facture patients for Paiements tab
                        fetchFacturePatients(medecinData.uid);
                    } else {
                        /*console.log("No matching medecin document found");*/
                    }
                } catch (error) {
                    /*console.error("Error fetching user data:", error);*/
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(false);
            }
        });
        
        return () => unsubscribe();
    }, []);

    // Fetch patients with facture = true for this medecin
    const fetchFacturePatients = async (medecinUid) => {
        setPaymentsLoading(true);
        try {
            const db = getFirestore();
            const patientsRef = collection(db, "patients");
            /*console.log('Searching for patients with userId:', medecinUid);*/
            
            // Get ALL patients for this medecin
            const allPatientsQuery = query(patientsRef, where("userId", "==", medecinUid));
            const allPatientsSnapshot = await getDocs(allPatientsQuery);
            const allPatients = allPatientsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            /*console.log('ALL patients for this medecin:', allPatients);*/
            
            // Filter by factureDate in the component, not here
            setFacturePatients(allPatients);
        } catch (e) {
            /*console.error('Error fetching facture patients:', e);*/
            setFacturePatients([]);
        }
        setPaymentsLoading(false);
    };

    return (
        <>
        <HeaderBlack/>
        <main>{/*}
        <div className={styles.welcomeSection}>
                  <p>Bonjour, <br /><span className={styles.doctorName}>Dr {userName || 'Utilisateur'}</span></p>
                  <div className={styles.banner}>
                    <img src={banner} alt="Practice Performance Banner" />
                  </div>
                </div>*/}
        <StatusCard/>
        <div className={styles.container}>
          <div className={styles.tabs}>
            <div 
              className={activeTab === 'profile' ? styles.tabActive : styles.tab}
              onClick={() => setActiveTab('profile')}
            >
              Profil
            </div>
            <div
              className={activeTab === 'paiements' ? styles.tabActive : styles.tab}
              onClick={() => setActiveTab('paiements')}
              style={{ cursor: 'pointer' }}
            >
              Paiements
            </div>
          </div>
          
          {loading ? (
            <div className={styles.loading}>Chargement...</div>
          ) : (
            activeTab === 'profile' ? (
              <ProfileView userData={userData} setUserData={setUserData} />
            ) : (
              <PaymentsView
                patients={facturePatients}
                medecinName={userData?.name}
                loading={paymentsLoading}
                userData={userData}
              />
            )
          )}
        </div>
        </main>
        </>
    );
};

const ProfileView = ({ userData, setUserData }) => {
    const [editMode, setEditMode] = useState({
        address: false,
        phone: false,
        email: false,
        password: false,
        licenseNumber: false,
        city: false,
        country: false
    });
    
    const [formData, setFormData] = useState({
        address: userData?.reason || '',
        phone: userData?.phoneNumber || '',
        email: userData?.email || '',
        licenseNumber: userData?.medicalLicenseNumber || '',
        city: userData?.city || '',
        country: userData?.country || '',
        newPassword: '',
        confirmPassword: ''
    });
    
    const [saving, setSaving] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [uploadingImage, setUploadingImage] = useState(false);
    const fileInputRef = useRef(null);

    const handleImageClick = () => {
        fileInputRef.current?.click();
    };

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file || !userData?.id) return;

        // Check if file is an image
        if (!file.type.startsWith('image/')) {
            alert('Veuillez sélectionner une image valide');
            return;
        }

        setUploadingImage(true);
        try {
            const storage = getStorage();
            const storageRef = ref(storage, `profile/${userData.id}/profileimg`);
            
            // Upload the file
            await uploadBytes(storageRef, file);
            
            // Get the download URL
            const downloadURL = await getDownloadURL(storageRef);
            
            // Update the user document in Firestore
            const db = getFirestore();
            const medecinRef = doc(db, "medecins", userData.id);
            await updateDoc(medecinRef, {
                profileImage: downloadURL,
                updatedAt: new Date()
            });

            // Update local state
            setUserData(prev => ({
                ...prev,
                profileImage: downloadURL
            }));

        } catch (error) {
            /*console.error("Error uploading image:", error);*/
            alert("Une erreur s'est produite lors du téléchargement de l'image.");
        } finally {
            setUploadingImage(false);
        }
    };
    
    useEffect(() => {
        if (userData) {
            setFormData({
                address: userData.reason || '',
                phone: userData.phoneNumber || '',
                email: userData.email || '',
                licenseNumber: userData.medicalLicenseNumber || '',
                city: userData.city || '',
                country: userData.country || '',
                newPassword: '',
                confirmPassword: ''
            });
        }
    }, [userData]);
    
    const handleEdit = (field) => {
        // Reset any previous password errors if editing password
        if (field === 'password') {
            setPasswordError('');
            setFormData({
                ...formData,
                newPassword: '',
                confirmPassword: ''
            });
        }
        setEditMode({ ...editMode, [field]: true });
    };
    
    const handleChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
        
        // Clear password error when user types
        if (field === 'newPassword' || field === 'confirmPassword') {
            setPasswordError('');
        }
    };
    
    const handleSave = async (field) => {
        if (!userData?.id) return;
        
        // Special handling for password
        if (field === 'password') {
            if (formData.newPassword !== formData.confirmPassword) {
                setPasswordError('Les mots de passe ne correspondent pas');
                return;
            }
            
            if (formData.newPassword.length < 6) {
                setPasswordError('Le mot de passe doit contenir au moins 6 caractères');
                return;
            }
            
            setSaving(true);
            try {
                const auth = getAuth();
                
                // Update password
                await updatePassword(auth.currentUser, formData.newPassword);
                
                // Reset fields and exit edit mode
                setFormData({
                    ...formData,
                    newPassword: '',
                    confirmPassword: ''
                });
                setEditMode({ ...editMode, password: false });
                alert('Mot de passe mis à jour avec succès');
            } catch (error) {
                /*console.error("Error updating password:", error);*/
                setPasswordError(error.message || 'Erreur lors de la mise à jour du mot de passe');
                
                // If the error is due to re-authentication required
                if (error.code === 'auth/requires-recent-login') {
                    alert('Pour des raisons de sécurité, veuillez vous reconnecter avant de modifier votre mot de passe');
                    // You could implement a re-authentication flow here
                }
            } finally {
                setSaving(false);
            }
            return;
        }
        
        setSaving(true);
        try {
            const db = getFirestore();
            const medecinRef = doc(db, "medecins", userData.id);
            
            // Map form fields to database fields
            const fieldMapping = {
                address: "reason",
                phone: "phoneNumber",
                email: "email",
                licenseNumber: "medicalLicenseNumber",
                city: "city",
                country: "country"
            };
            
            // Update only the specific field
            await updateDoc(medecinRef, {
                [fieldMapping[field]]: formData[field],
                updatedAt: new Date()
            });
            
            // Exit edit mode
            setEditMode({ ...editMode, [field]: false });
        } catch (error) {
            /*console.error("Error updating profile:", error);*/
            alert("Une erreur s'est produite lors de la mise à jour du profil.");
        } finally {
            setSaving(false);
        }
    };
    
    const handleCancel = (field) => {
        // Reset the field to original value and exit edit mode
        const fieldMapping = {
            address: "reason",
            phone: "phoneNumber",
            email: "email",
            licenseNumber: "medicalLicenseNumber",
            city: "city",
            country: "country"
        };
        
        if (field === 'password') {
            setFormData({
                ...formData,
                newPassword: '',
                confirmPassword: ''
            });
            setPasswordError('');
        } else {
            setFormData({
                ...formData,
                [field]: userData?.[fieldMapping[field]] || formData[field]
            });
        }
        
        setEditMode({ ...editMode, [field]: false });
    };
    
    // Improved styling for input fields
    const inputStyle = {
        width: '100%',
        padding: '10px 12px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        fontSize: '14px',
        marginBottom: '10px',
        backgroundColor: '#f8f9fa',
        transition: 'border-color 0.3s, box-shadow 0.3s',
        outline: 'none'
    };
    
    const buttonStyle = {
        padding: '8px 16px',
        borderRadius: '4px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        margin: '0 5px'
    };
    
    const saveButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none'
    };
    
    const cancelButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#f1f1f1',
        color: '#333',
        border: '1px solid #ddd'
    };
    
    return (
        <div className={styles.content}>
            <h2 className={styles.pageTitle}>Profil du praticien {userData?.name || 'Atef Ben Boubaker'}</h2>
            
            <div className={styles.twoColumnLayout}>
                {/* Left Column - Profile Info */}
                <div className={styles.leftColumn}>
                    <div className={styles.profileCard}>
                        <div 
                            className={styles.profileImageContainer}
                            onClick={handleImageClick}
                            style={{ cursor: 'pointer', position: 'relative' }}
                        >
                            {userData?.profileImage ? (
                                <img 
                                    src={userData.profileImage} 
                                    alt="Profile" 
                                    className={styles.profileImage} 
                                />
                            ) : (
                                <svg 
                                    viewBox="0 0 24 24" 
                                    className={styles.anonymousIcon}
                                    fill="currentColor"
                                >
                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                                </svg>
                            )}
                            <div className={styles.cameraIcon}>
                                <svg 
                                    viewBox="0 0 24 24" 
                                    width="24" 
                                    height="24"
                                    fill="white"
                                >
                                    <path d="M12 15.2a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4z"/>
                                    <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
                                </svg>
                            </div>
                            {uploadingImage && (
                                <div className={styles.uploadingOverlay}>
                                    <div className={styles.spinner}></div>
                                </div>
                            )}
                        </div>
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleImageUpload}
                            accept="image/*"
                            style={{ display: 'none' }}
                        />
                        
                        <h3 className={styles.profileName}>{userData?.name}</h3>
                        <p className={styles.profileSpecialty}>
                            • Spécialité : {userData?.role || 'Dentiste omnipraticien / Orthodontiste'}
                        </p>
                    </div>
                </div>
                
                {/* Right Column - Details */}
                <div className={styles.rightColumn}>
                    <div className={styles.profileDetails}>
                        <div className={styles.detailRow}>
                            <div className={styles.detailBullet}>•</div>
                            <div className={styles.detailContent}>
                                <div className={styles.detailLabel}>Adresse professionnelle :</div>
                                {editMode.address ? (
                                    <div className={styles.editField}>
                                        <input 
                                            type="text" 
                                            value={formData.address} 
                                            onChange={(e) => handleChange('address', e.target.value)}
                                            style={inputStyle}
                                        />
                                        <div className={styles.editActions}>
                                            <button 
                                                onClick={() => handleSave('address')} 
                                                disabled={saving}
                                                style={saveButtonStyle}
                                            >
                                                {saving ? 'Enregistrement...' : 'Enregistrer'}
                                            </button>
                                            <button 
                                                onClick={() => handleCancel('address')}
                                                style={cancelButtonStyle}
                                            >
                                                Annuler
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.detailValue}>{formData.address}</div>
                                )}
                            </div>
                            {!editMode.address && (
                                <button 
                                    className={styles.modifyButton}
                                    onClick={() => handleEdit('address')}
                                >
                                    Modifier
                                </button>
                            )}
                        </div>
                        
                        <div className={styles.divider}></div>
                        
                        <div className={styles.detailRow}>
                            <div className={styles.detailBullet}>•</div>
                            <div className={styles.detailContent}>
                                <div className={styles.detailLabel}>Ville :</div>
                                {editMode.city ? (
                                    <div className={styles.editField}>
                                        <input 
                                            type="text" 
                                            value={formData.city} 
                                            onChange={(e) => handleChange('city', e.target.value)}
                                            style={inputStyle}
                                        />
                                        <div className={styles.editActions}>
                                            <button 
                                                onClick={() => handleSave('city')} 
                                                disabled={saving}
                                                style={saveButtonStyle}
                                            >
                                                {saving ? 'Enregistrement...' : 'Enregistrer'}
                                            </button>
                                            <button 
                                                onClick={() => handleCancel('city')}
                                                style={cancelButtonStyle}
                                            >
                                                Annuler
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.detailValue}>{formData.city}</div>
                                )}
                            </div>
                            {!editMode.city && (
                                <button 
                                    className={styles.modifyButton}
                                    onClick={() => handleEdit('city')}
                                >
                                    Modifier
                                </button>
                            )}
                        </div>
                        
                        <div className={styles.divider}></div>
                        
                        <div className={styles.detailRow}>
                            <div className={styles.detailBullet}>•</div>
                            <div className={styles.detailContent}>
                                <div className={styles.detailLabel}>Pays :</div>
                                {editMode.country ? (
                                    <div className={styles.editField}>
                                        <input 
                                            type="text" 
                                            value={formData.country} 
                                            onChange={(e) => handleChange('country', e.target.value)}
                                            style={inputStyle}
                                        />
                                        <div className={styles.editActions}>
                                            <button 
                                                onClick={() => handleSave('country')} 
                                                disabled={saving}
                                                style={saveButtonStyle}
                                            >
                                                {saving ? 'Enregistrement...' : 'Enregistrer'}
                                            </button>
                                            <button 
                                                onClick={() => handleCancel('country')}
                                                style={cancelButtonStyle}
                                            >
                                                Annuler
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.detailValue}>{formData.country}</div>
                                )}
                            </div>
                            {!editMode.country && (
                                <button 
                                    className={styles.modifyButton}
                                    onClick={() => handleEdit('country')}
                                >
                                    Modifier
                                </button>
                            )}
                        </div>
                        
                        <div className={styles.divider}></div>
                        
                        <div className={styles.detailRow}>
                            <div className={styles.detailBullet}>•</div>
                            <div className={styles.detailContent}>
                                <div className={styles.detailLabel}>Numéro de Téléphone :</div>
                                {editMode.phone ? (
                                    <div className={styles.editField}>
                                        <input 
                                            type="text" 
                                            value={formData.phone} 
                                            onChange={(e) => handleChange('phone', e.target.value)}
                                            style={inputStyle}
                                        />
                                        <div className={styles.editActions}>
                                            <button 
                                                onClick={() => handleSave('phone')} 
                                                disabled={saving}
                                                style={saveButtonStyle}
                                            >
                                                {saving ? 'Enregistrement...' : 'Enregistrer'}
                                            </button>
                                            <button 
                                                onClick={() => handleCancel('phone')}
                                                style={cancelButtonStyle}
                                            >
                                                Annuler
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.detailValue}>{formData.phone}</div>
                                )}
                            </div>
                            {!editMode.phone && (
                                <button 
                                    className={styles.modifyButton}
                                    onClick={() => handleEdit('phone')}
                                >
                                    Modifier
                                </button>
                            )}
                        </div>
                        
                        <div className={styles.divider}></div>
                        
                        <div className={styles.detailRow}>
                            <div className={styles.detailBullet}>•</div>
                            <div className={styles.detailContent}>
                                <div className={styles.detailLabel}>Identifiant et adresse e-mail principale</div>
                                {editMode.email ? (
                                    <div className={styles.editField}>
                                        <input 
                                            type="email" 
                                            value={formData.email} 
                                            onChange={(e) => handleChange('email', e.target.value)}
                                            style={inputStyle}
                                        />
                                        <div className={styles.editActions}>
                                            <button 
                                                onClick={() => handleSave('email')} 
                                                disabled={saving}
                                                style={saveButtonStyle}
                                            >
                                                {saving ? 'Enregistrement...' : 'Enregistrer'}
                                            </button>
                                            <button 
                                                onClick={() => handleCancel('email')}
                                                style={cancelButtonStyle}
                                            >
                                                Annuler
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.detailValue}>{formData.email}</div>
                                )}
                            </div>
                            {!editMode.email && (
                                <button 
                                    className={styles.modifyButton}
                                    onClick={() => handleEdit('email')}
                                >
                                    Modifier
                                </button>
                            )}
                        </div>
                        
                        <div className={styles.divider}></div>
                        
                        <div className={styles.detailRow}>
                            <div className={styles.detailBullet}>•</div>
                            <div className={styles.detailContent}>
                                <div className={styles.detailLabel}>Mot de Passe</div>
                                {editMode.password ? (
                                    <div className={styles.editField}>
                                        <input 
                                            type="password" 
                                            placeholder="Nouveau mot de passe"
                                            value={formData.newPassword}
                                            onChange={(e) => handleChange('newPassword', e.target.value)}
                                            style={inputStyle}
                                        />
                                        <input 
                                            type="password" 
                                            placeholder="Confirmer le mot de passe"
                                            value={formData.confirmPassword}
                                            onChange={(e) => handleChange('confirmPassword', e.target.value)}
                                            style={{...inputStyle, marginTop: '8px'}}
                                        />
                                        {passwordError && (
                                            <div style={{color: 'red', marginBottom: '10px', fontSize: '14px'}}>
                                                {passwordError}
                                            </div>
                                        )}
                                        <div className={styles.editActions}>
                                            <button 
                                                onClick={() => handleSave('password')}
                                                disabled={saving}
                                                style={saveButtonStyle}
                                            >
                                                {saving ? 'Enregistrement...' : 'Enregistrer'}
                                            </button>
                                            <button 
                                                onClick={() => handleCancel('password')}
                                                style={cancelButtonStyle}
                                            >
                                                Annuler
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.detailValue}>****************</div>
                                )}
                            </div>
                            {!editMode.password && (
                                <button 
                                    className={styles.modifyButton}
                                    onClick={() => handleEdit('password')}
                                >
                                    Modifier
                                </button>
                            )}
                        </div>
                        
                        <div className={styles.divider}></div>
                        
                        <div className={styles.detailRow}>
                            <div className={styles.detailBullet}>•</div>
                            <div className={styles.detailContent}>
                                <div className={styles.detailLabel}>Numero d'inscription à l'ordres de médecins dentistes</div>
                                {editMode.licenseNumber ? (
                                    <div className={styles.editField}>
                                        <input 
                                            type="text" 
                                            value={formData.licenseNumber} 
                                            onChange={(e) => handleChange('licenseNumber', e.target.value)}
                                            style={inputStyle}
                                        />
                                        <div className={styles.editActions}>
                                            <button 
                                                onClick={() => handleSave('licenseNumber')} 
                                                disabled={saving}
                                                style={saveButtonStyle}
                                            >
                                                {saving ? 'Enregistrement...' : 'Enregistrer'}
                                            </button>
                                            <button 
                                                onClick={() => handleCancel('licenseNumber')}
                                                style={cancelButtonStyle}
                                            >
                                                Annuler
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.detailValue}>{formData.licenseNumber}</div>
                                )}
                            </div>
                            {!editMode.licenseNumber && (
                                <button 
                                    className={styles.modifyButton}
                                    onClick={() => handleEdit('licenseNumber')}
                                >
                                    Modifier
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PaymentsView = ({ patients, medecinName, loading, userData }) => {
    // Only show patients with factureDate
    const filteredPatients = patients.filter(p => {
        const hasFactureDate = p.factureDate;
        console.log(`Patient ${p.id} (${p.name}): factureDate =`, p.factureDate, 'Type:', typeof p.factureDate);
        return hasFactureDate;
    });
    
    /*console.log('PaymentsView - All patients received:', patients);*/
    /*console.log('PaymentsView - Patients with factureDate:', filteredPatients);*/
    /*console.log('PaymentsView - Patients without factureDate:', patients.filter(p => !p.factureDate));*/
    
    return (
        <div className={styles.content}>
            <div className={styles.tableContainer}>
                <table className={styles.paymentsTable}>
                    <thead>
                        <tr>
                            <th className={styles.checkboxColumn}>
                                <input type="checkbox" />
                            </th>
                            <th>Factures</th>
                            <th>Patient (en)</th>
                            <th>ID patient</th>
                            <th>Facture Date de</th>
                            <th>Facture somme (TND)</th>
                            <th>Payé Somme (TND)</th>
                            <th>Reste somme (TND)</th>
                            <th>Date de Paiement</th>
                            <th>Télécharger la facture</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan={10} style={{ textAlign: 'center' }}>Chargement...</td></tr>
                        ) : filteredPatients.length === 0 ? (
                            <tr><td colSpan={10} style={{ textAlign: 'center' }}>Aucune facture trouvée.</td></tr>
                        ) : (
                            filteredPatients.map((patient, idx) => (
                                <tr key={patient.id} style={{ whiteSpace: 'nowrap' }}>
                                    <td><input type="checkbox" /></td>
                                    <td>{idx + 1}</td>
                                    <td>{patient.name} {patient.surname}</td>
                                    <td>{patient.id}</td>
                                    <td>{patient.factureDate ? new Date(patient.factureDate).toLocaleDateString() : '-'}</td>
                                    <td>{(() => {
                                        // Get base price (prioritize price, then basePrice, then baseprice)
                                        const basePrice = typeof patient.price === 'number'
                                          ? patient.price
                                          : (typeof patient.basePrice === 'number'
                                              ? patient.basePrice
                                              : (typeof patient.baseprice === 'number'
                                                  ? patient.baseprice
                                                  : 0));
                                        const discountPercent = typeof patient.discount === 'number' ? patient.discount : 0;
                                        const discountAmount = (basePrice * discountPercent) / 100;
                                        const sousTotal = basePrice - discountAmount;
                                        const tva = sousTotal * 0.19;
                                        const timbre = 1.0;
                                        const total = sousTotal + tva + timbre;
                                        return (
                                            <span title={`Prix: ${basePrice.toFixed(3)} - Remise: ${discountAmount.toFixed(3)} + TVA: ${tva.toFixed(3)} + Timbre: ${timbre.toFixed(3)}`}>
                                                {total.toFixed(3)} TND
                                            </span>
                                        );
                                    })()}</td>
                                    <td>{typeof patient.payedAmount === 'number' ? patient.payedAmount.toFixed(3) + ' TND' : '0 TND'}</td>
                                    <td>{(() => {
                                        // Get base price (prioritize price, then basePrice, then baseprice)
                                        const basePrice = typeof patient.price === 'number'
                                          ? patient.price
                                          : (typeof patient.basePrice === 'number'
                                              ? patient.basePrice
                                              : (typeof patient.baseprice === 'number'
                                                  ? patient.baseprice
                                                  : 0));
                                        const discountPercent = typeof patient.discount === 'number' ? patient.discount : 0;
                                        const discountAmount = (basePrice * discountPercent) / 100;
                                        const sousTotal = basePrice - discountAmount;
                                        const tva = sousTotal * 0.19;
                                        const timbre = 1.0;
                                        const total = sousTotal + tva + timbre;
                                        const payed = typeof patient.payedAmount === 'number' ? patient.payedAmount : 0;
                                        const reste = total - payed;
                                        return reste.toFixed(3) + ' TND';
                                    })()}</td>
                                    <td>{patient.paiementDate ? new Date(patient.paiementDate).toLocaleDateString() : '-'}</td>
                                    <td>
                                        <button style={{ padding: '4px 12px', borderRadius: '4px', background: '#05B4B2', color: 'white', border: 'none', cursor: 'pointer' }}
                                            onClick={() => generateInvoicePDF(patient, userData)}>
                                            Télécharger
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                <div className={styles.pagination}>
                    <span className={styles.paginationActive}>1</span>
                    <span className={styles.paginationItem}>2</span>
                    <span className={styles.paginationItem}>3</span>
                    <span>Suivant</span>
                </div>
                <div className={styles.downloadButton}>
                    <button>Télécharger les factures</button>
                </div>
            </div>
        </div>
    );
};

export default ProfileMedecin;